import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, FormGroup, FormText, Button, Input, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import ReactSelect from 'react-select';
import FormItem from '../../../common/forms/FormItem';
import { isRequired, validateEndDate } from '../../../../utils/validators';
import RegisteredBusSelect from '../../../common/forms/select/RegisteredBusSelect';
import DatePicker from '../../../common/forms/input/DatePicker';

const CIRCUIT_TYPE_OPTIONS = [
  { value: 'Simple', label: 'Simple' },
  { value: 'Compuesto', label: 'Compuesto' },
];

const circuitIdField = ({ input, meta, ...rest }) => (
  <Input
    {...input}
    {...rest}
    type="number"
    min="1"
    placeholder="ID circuito (itinerario.circuitId)"
    onChange={(e) =>
      input.onChange(e.target.value === '' ? '' : Number(e.target.value))
    }
  />
);

const northChicoCheckbox = ({ input, id, label }) => (
  <FormGroup check className="mb-0">
    <Label check htmlFor={id}>
      <Input
        id={id}
        type="checkbox"
        checked={Boolean(input.value)}
        onChange={(e) => input.onChange(e.target.checked)}
        onBlur={input.onBlur}
      />{' '}
      {label}
    </Label>
  </FormGroup>
);

const circuitTypesField = ({ input, ...rest }) => (
  <ReactSelect
    {...rest}
    isMulti
    isClearable
    placeholder="Opcional"
    options={CIRCUIT_TYPE_OPTIONS}
    value={CIRCUIT_TYPE_OPTIONS.filter((o) => (input.value || []).includes(o.value))}
    onChange={(opts) => input.onChange((opts || []).map((o) => o.value))}
    menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
    styles={{
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    }}
  />
);

export class FuelDataCompletenessReportSearchForm extends Component {
  validateDate = (value, allValues) =>
    validateEndDate(value, allValues.fromDate);

  render() {
    return (
      <Form onSubmit={this.props.handleSubmit}>
        <FormGroup row>
          <FormItem label="Bus (opcional)">
            <Field
              name="registeredBusId"
              component={RegisteredBusSelect}
              isMulti
            />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Circuito — ID en itinerario (opcional)">
            <Field name="circuitId" component={circuitIdField} />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Tipo de circuito (opcional)">
            <Field name="circuitTypes" component={circuitTypesField} />
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <Col md="12">
            <Field
              name="includeNorthChicoRoutes"
              id="includeNorthChicoRoutes"
              component={northChicoCheckbox}
              label="Incluir itinerarios con ruta “Pertenece a Norte Chico”"
            />
            <FormText color="muted">
              Si no marcas esta opción, esos itinerarios quedan fuera del reporte.
            </FormText>
          </Col>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Fecha" required>
            <Row>
              <Col>
                <Field
                  name="fromDate"
                  component={DatePicker}
                  placeholder="Fecha de Inicio"
                  validate={[isRequired]}
                />
              </Col>
              <Col>
                <Field
                  name="toDate"
                  component={DatePicker}
                  placeholder="Fecha de Fin"
                  validate={[isRequired, this.validateDate]}
                />
              </Col>
            </Row>
          </FormItem>
        </FormGroup>
        <Row>
          <Col className="flex row-reverse">
            <Button type="submit" color="secondary" outline>
              <i className="fa fa-search" /> Buscar
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

FuelDataCompletenessReportSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'FuelDataCompletenessReportSearchForm',
  initialValues: { circuitTypes: [], includeNorthChicoRoutes: false },
})(FuelDataCompletenessReportSearchForm);
